import './details/api/GroupsDetailsAPI.js';
import './entities/Group.js';
import './entities/Kostenstelle.js';
import './entities/School.js';
import './GroupFilterAspect.js';
